// src/features/etichette/EtichettePage.jsx
import React, { useMemo, useState } from "react";
import { PlusCircle, History } from "lucide-react";
import TopBar from "../../components/TopBar";
import StampaEtichette from "./StampaEtichette";
import StoricoEtichette from "./StoricoEtichette";

export default function EtichettePage() {
  const [tab, setTab] = useState("gestione"); // "gestione" | "storico"

  const header = useMemo(() => {
    if (tab === "gestione") {
      return {
        title: "Gestione Etichette",
        subtitle: "Genera nuove etichette di produzione e traccia i lotti.",
      };
    }
    return {
      title: "Storico Etichette",
      subtitle: "Consulta e gestisci lo storico di tutte le etichette generate.",
    };
  }, [tab]);

  return (
    <>
      {/* TopBar standard progetto */}
      <TopBar title="NORMA HACCP — Etichette" showBack />

      <div className="min-h-screen bg-[#F6F8FA] text-slate-800 p-4 md:p-6">
        <main className="max-w-7xl mx-auto space-y-6">
          {/* Header sezione + tabs */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold text-slate-800">
                {header.title}
              </h2>
              <p className="text-slate-500 text-sm mt-1">{header.subtitle}</p>
            </div>

            <div className="flex items-center bg-white p-1 rounded-full shadow-sm border border-slate-200 w-full md:w-auto shrink-0">
              <button
                type="button"
                onClick={() => setTab("gestione")}
                className={[
                  "flex-1 md:flex-none px-5 py-2 rounded-full text-sm font-semibold transition flex items-center justify-center gap-2",
                  tab === "gestione"
                    ? "bg-[#0B3A66] text-white shadow"
                    : "text-slate-500 hover:bg-slate-50",
                ].join(" ")}
              >
                <PlusCircle className="w-4 h-4" />
                Gestione
              </button>

              <button
                type="button"
                onClick={() => setTab("storico")}
                className={[
                  "flex-1 md:flex-none px-5 py-2 rounded-full text-sm font-semibold transition flex items-center justify-center gap-2",
                  tab === "storico"
                    ? "bg-[#0B3A66] text-white shadow"
                    : "text-slate-500 hover:bg-slate-50",
                ].join(" ")}
              >
                <History className="w-4 h-4" />
                Storico
              </button>
            </div>
          </div>

          {/* Contenuto */}
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 md:p-6">
            {tab === "gestione" ? <StampaEtichette /> : <StoricoEtichette />}
          </div>
        </main>
      </div>
    </>
  );
}